<div class="full-height display-flex flex-center">
    <sfx-loader translationKey="auth.redirecting_to_login"></sfx-loader>
</div>
